module.exports = __webpack_public_path__ + "static/media/about-img3.d32a8dc5.svg";